/** @format */

import React, { FunctionComponent } from 'react';
import { TableBody, TableCell, TableHead } from '@material-ui/core';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import TableRow from '@material-ui/core/TableRow';
import TableHeaderContentCell from '../../components/Table/TableHeaderContentCell';
import EditButton from '../../components/Buttons/EditButton';
import PlatformUserDefinedRolesInterface from '../../interfaces/platform/PlatformUserDefinedRolesInterface';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';

export type UserPermissionGroupListItemType = {
    classes: any;
    collectionsItems: Array<PlatformUserDefinedRolesInterface> | null;
    // viewCallback: (iri: { uri: string }, event: any) => void;
    firstLoad: () => void;
    setActiveRow: (id: number) => void;
    activeRow: number;
    updateOrderList: (orders: Array<Order>) => void;
    updateFilterList: (filters: Array<Filter>) => void;
    filters: Array<Filter>;
    orders: Array<Order>;
    editCallback: (data: { id: number }) => void;
    deleteCallback: (data: { id: number }) => void;
};

export const UserPermissionGroupListTable: FunctionComponent<UserPermissionGroupListItemType> = ({
    collectionsItems,
    classes,
    // viewCallback,
    updateOrderList,
    updateFilterList,
    setActiveRow,
    activeRow,
    firstLoad,
    filters,
    orders,
    editCallback,
    deleteCallback,
}): React.ReactElement => {
    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRoot };
    const tableRowRoot = { root: classes.tableRowRoot };
    const tableStickyCommand = { root: classes.tableStickyCommand };

    return (
        <React.Fragment>
            <TableHead>
                <TableRow>
                    <TableCell classes={tableStickyCommand} padding="none" align="left">
                        <TableHeaderContentCell textAlign="left" title="general:common.commands" onlyFilter={true} />
                    </TableCell>
                    <TableCell classes={tableStickyHeader} padding="none" align="left" style={{ paddingLeft: 10 }}>
                        <TableHeaderContentCell
                            textAlign="left"
                            title="permission_groups:h.mainname"
                            fieldName="mainname"
                            showSort={true}
                            onlyFilter={false}
                            defaultDirection="desc"
                            searchFieldType="string"
                            prependMaxLengthRequirement={9}
                            filters={filters}
                            sort={orders}
                            updateOrderList={updateOrderList}
                            updateFilterList={updateFilterList}
                            searchActionCallback={firstLoad}
                        />
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {collectionsItems?.map((item: PlatformUserDefinedRolesInterface) => {
                    let rowActiveColor = 'white';
                    if (activeRow === item.id) {
                        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
                    }
                    return (
                        <TableRow
                            classes={tableRowRoot}
                            key={'key' + item.id}
                            hover
                            onClick={(): void => {
                                setActiveRow(item.id);
                            }}
                            style={{ backgroundColor: rowActiveColor }}
                        >
                            <TableCell classes={tableControlStickyHeader} style={{ width: 30 }} padding="none" align="left">
                                <EditButton
                                    callback={editCallback}
                                    callbackParam={{ id: item.id }}
                                    tooltipTitle="permission_groups:a.edit_permission_group"
                                    tooltipPlacement="bottom-start"
                                />
                                {/* <DeleteButton
                                    color={'warning'}
                                    callback={deleteCallback}
                                    callbackParam={{ id: item.id }}
                                    tooltipTitle="permission_groups:a.delete_permission_group"
                                    tooltipPlacement="bottom-start"
                                /> */}
                            </TableCell>
                            <TableCell classes={tableCellRoot} style={{ paddingLeft: 10 }} padding="none" align="left">
                                {item.mainname}
                            </TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </React.Fragment>
    );
};
